export default {
  setAutomations(state, payload) {
    state.automations = payload;
  },
  setAutomationsReport(state, payload) {
    state.automationsReport = payload;
  }
};
